import { IVectorMaterialInfo } from '@meitu/saas-editor-core/es/version-types';
import { editor } from '@/instance';

export const useAddVectorLayer = () => {
    return {
        /**
         * 添加 SVG 素材
         *
         * @param params - 参数
         */
        async add({
            id,
            image,
            info,
            showLoading = true,
            byMousePosition = false,
        }: {
            id: number;
            image: string;
            info: string;
            showLoading?: boolean;
            byMousePosition?: boolean;
        }) {
            try {
                if (showLoading) {
                    editor.services.mask.show({
                        loading: true,
                        text: '加载中',
                    });
                }
                editor.vectorLayer.addByVectorMaterial(
                    {
                        id: String(id),
                        url: image,
                        info: JSON.parse(info) as IVectorMaterialInfo,
                    },
                    {
                        byMousePosition,
                    },
                );
            } catch (e) {
                if (showLoading) editor.services.mask.hide();
            } finally {
                if (showLoading) editor.services.mask.hide();
            }
        },
    };
};
